/*  Copyright (c) 2020 Bankers Healthcare Group All rights reserved  */
import { appApi } from '../api';

const state = {
  featureFlags: {},
  currentFeatures: {
    applyNaluRebrand: 'PL-1105-Rebrand-Borrower-Portal-UI',
  },
};

const getFeatureFlagsFromApi = async () => {
    const result = await appApi.get('features');
    return result.data;
};

/** @type import('vuex').GetterTree<state, any> */
const getters = {
  isFeatureFlagEnabled: s => featureName => s.featureFlags[featureName] ?? false,
};

const actions = {
  async getFeatureFlags(context) {
    try {
      const result = await getFeatureFlagsFromApi();
      context.commit('setFeatureFlags', result);
    } catch (error) {
      context.dispatch('setError', true);
    }
  },
  async isFeatureFlagEnabled(context, featureName){
      if (context.state.featureFlags[featureName] === undefined) {
        context.state.featureFlags = await getFeatureFlagsFromApi();
        context.commit('setFeatureFlags', context.state.featureFlags);
      }
      return context.state.featureFlags[featureName] ?? false;
  },
};

const mutations = {
    setFeatureFlags(s, features) {
    s.featureFlags = features;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
